import { FormBase } from 'core/components';

export default class ImportReferenceUploadForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'file',
                    label: 'IMPORT_REFERENCE.UPLOAD.FILE_LABEL',
                    placeholder: 'PRODUCT.UPLOAD.FILE_PLACEHOLDER',
                    type:'file'
                }
            ],
        };
    }
}
